/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Components_Performancetable_Movedup2Inputs */

const id_components_performancetable_movedup2 = /** @type {(inputs: Components_Performancetable_Movedup2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("id", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`Naik ${i?.count} posisi`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`Naik ${i?.count} posisi`);
	return /** @type {LocalizedString} */ ("components.performanceTable.movedUp");
};

const ms_components_performancetable_movedup2 = /** @type {(inputs: Components_Performancetable_Movedup2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("ms", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`Naik ${i?.count} tempat`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`Naik ${i?.count} tempat`);
	return /** @type {LocalizedString} */ ("components.performanceTable.movedUp");
};

const da_components_performancetable_movedup2 = /** @type {(inputs: Components_Performancetable_Movedup2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("da", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`Rykkede op ${i?.count} plads`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`Rykkede op ${i?.count} pladser`);
	return /** @type {LocalizedString} */ ("components.performanceTable.movedUp");
};

const de_components_performancetable_movedup2 = /** @type {(inputs: Components_Performancetable_Movedup2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("de", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} Platz aufgestiegen`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} Plätze aufgestiegen`);
	return /** @type {LocalizedString} */ ("components.performanceTable.movedUp");
};

const en_us2_components_performancetable_movedup2 = /** @type {(inputs: Components_Performancetable_Movedup2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("en-US", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`Moved up ${i?.count} place`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`Moved up ${i?.count} places`);
	return /** @type {LocalizedString} */ ("components.performanceTable.movedUp");
};

const es_es2_components_performancetable_movedup2 = /** @type {(inputs: Components_Performancetable_Movedup2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("es-ES", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`Subió ${i?.count} puesto`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`Subió ${i?.count} puestos`);
	return /** @type {LocalizedString} */ ("components.performanceTable.movedUp");
};

const es_mx2_components_performancetable_movedup2 = /** @type {(inputs: Components_Performancetable_Movedup2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("es-MX", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`Subió ${i?.count} posición`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`Subió ${i?.count} posiciones`);
	return /** @type {LocalizedString} */ ("components.performanceTable.movedUp");
};

const fil_components_performancetable_movedup2 = /** @type {(inputs: Components_Performancetable_Movedup2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("fil", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`Umakyat ng ${i?.count} puwesto`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`Umakyat ng ${i?.count} puwesto`);
	return /** @type {LocalizedString} */ ("components.performanceTable.movedUp");
};

const fr_components_performancetable_movedup2 = /** @type {(inputs: Components_Performancetable_Movedup2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("fr", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`Monté de ${i?.count} place`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`Monté de ${i?.count} places`);
	return /** @type {LocalizedString} */ ("components.performanceTable.movedUp");
};

const it_components_performancetable_movedup2 = /** @type {(inputs: Components_Performancetable_Movedup2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("it", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`Salito di ${i?.count} posizione`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`Salito di ${i?.count} posizioni`);
	return /** @type {LocalizedString} */ ("components.performanceTable.movedUp");
};

const hu_components_performancetable_movedup2 = /** @type {(inputs: Components_Performancetable_Movedup2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("hu", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} helyet lépett előre`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} helyet lépett előre`);
	return /** @type {LocalizedString} */ ("components.performanceTable.movedUp");
};

const nl_components_performancetable_movedup2 = /** @type {(inputs: Components_Performancetable_Movedup2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("nl", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} plaats gestegen`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} plaatsen gestegen`);
	return /** @type {LocalizedString} */ ("components.performanceTable.movedUp");
};

const no_components_performancetable_movedup2 = /** @type {(inputs: Components_Performancetable_Movedup2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("no", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`Flyttet opp ${i?.count} plass`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`Flyttet opp ${i?.count} plasser`);
	return /** @type {LocalizedString} */ ("components.performanceTable.movedUp");
};

const pl_components_performancetable_movedup2 = /** @type {(inputs: Components_Performancetable_Movedup2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("pl", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`Przesunięcie w górę o ${i?.count} miejsce`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`Przesunięcie w górę o ${i?.count} miejsc`);
	return /** @type {LocalizedString} */ ("components.performanceTable.movedUp");
};

const pt_br2_components_performancetable_movedup2 = /** @type {(inputs: Components_Performancetable_Movedup2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("pt-BR", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`Subiu ${i?.count} posição`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`Subiu ${i?.count} posições`);
	return /** @type {LocalizedString} */ ("components.performanceTable.movedUp");
};

const pt_components_performancetable_movedup2 = /** @type {(inputs: Components_Performancetable_Movedup2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("pt", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`Subiu ${i?.count} lugar`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`Subiu ${i?.count} lugares`);
	return /** @type {LocalizedString} */ ("components.performanceTable.movedUp");
};

const ro_components_performancetable_movedup2 = /** @type {(inputs: Components_Performancetable_Movedup2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("ro", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`Urcat ${i?.count} poziție`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`Urcat ${i?.count} poziții`);
	return /** @type {LocalizedString} */ ("components.performanceTable.movedUp");
};

const fi_components_performancetable_movedup2 = /** @type {(inputs: Components_Performancetable_Movedup2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("fi", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`Nousi ${i?.count} sijan`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`Nousi ${i?.count} sijaa`);
	return /** @type {LocalizedString} */ ("components.performanceTable.movedUp");
};

const sv_components_performancetable_movedup2 = /** @type {(inputs: Components_Performancetable_Movedup2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("sv", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`Flyttades upp ${i?.count} plats`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`Flyttades upp ${i?.count} platser`);
	return /** @type {LocalizedString} */ ("components.performanceTable.movedUp");
};

const vi_components_performancetable_movedup2 = /** @type {(inputs: Components_Performancetable_Movedup2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("vi", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`Tăng ${i?.count} bậc`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`Tăng ${i?.count} bậc`);
	return /** @type {LocalizedString} */ ("components.performanceTable.movedUp");
};

const tr_components_performancetable_movedup2 = /** @type {(inputs: Components_Performancetable_Movedup2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("tr", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} sıra yükseldi`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} sıra yükseldi`);
	return /** @type {LocalizedString} */ ("components.performanceTable.movedUp");
};

const cs_components_performancetable_movedup2 = /** @type {(inputs: Components_Performancetable_Movedup2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("cs", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`Posunuto nahoru o ${i?.count} místo`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`Posunuto nahoru o ${i?.count} míst`);
	return /** @type {LocalizedString} */ ("components.performanceTable.movedUp");
};

const bg_components_performancetable_movedup2 = /** @type {(inputs: Components_Performancetable_Movedup2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("bg", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`Качена с ${i?.count} позиция`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`Качена с ${i?.count} позиции`);
	return /** @type {LocalizedString} */ ("components.performanceTable.movedUp");
};

const ru_components_performancetable_movedup2 = /** @type {(inputs: Components_Performancetable_Movedup2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("ru", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`Поднялся на ${i?.count} место`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`Поднялся на ${i?.count} мест(а)`);
	return /** @type {LocalizedString} */ ("components.performanceTable.movedUp");
};

const uk_components_performancetable_movedup2 = /** @type {(inputs: Components_Performancetable_Movedup2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("uk", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`Піднявся на ${i?.count} місце`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`Піднявся на ${i?.count} місць`);
	return /** @type {LocalizedString} */ ("components.performanceTable.movedUp");
};

const ar_components_performancetable_movedup2 = /** @type {(inputs: Components_Performancetable_Movedup2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("ar", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`ارتفع ${i?.count} مركز`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`ارتفع ${i?.count} مركز`);
	return /** @type {LocalizedString} */ ("components.performanceTable.movedUp");
};

const hi_components_performancetable_movedup2 = /** @type {(inputs: Components_Performancetable_Movedup2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("hi", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} स्थान ऊपर चला गया`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} स्थान ऊपर चले गए`);
	return /** @type {LocalizedString} */ ("components.performanceTable.movedUp");
};

const th_components_performancetable_movedup2 = /** @type {(inputs: Components_Performancetable_Movedup2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("th", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`ขยับขึ้น ${i?.count} อันดับ`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`ขยับขึ้น ${i?.count} อันดับ`);
	return /** @type {LocalizedString} */ ("components.performanceTable.movedUp");
};

const ja_components_performancetable_movedup2 = /** @type {(inputs: Components_Performancetable_Movedup2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("ja", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} 位上昇`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} 位上昇`);
	return /** @type {LocalizedString} */ ("components.performanceTable.movedUp");
};

const zh_cn2_components_performancetable_movedup2 = /** @type {(inputs: Components_Performancetable_Movedup2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("zh-CN", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`上升 ${i?.count} 名`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`上升 ${i?.count} 名`);
	return /** @type {LocalizedString} */ ("components.performanceTable.movedUp");
};

const zh_hant1_components_performancetable_movedup2 = /** @type {(inputs: Components_Performancetable_Movedup2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("zh-Hant", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`上升 ${i?.count} 名`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`上升 ${i?.count} 名`);
	return /** @type {LocalizedString} */ ("components.performanceTable.movedUp");
};

const ko_components_performancetable_movedup2 = /** @type {(inputs: Components_Performancetable_Movedup2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("ko", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count}계단 상승`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count}계단 상승`);
	return /** @type {LocalizedString} */ ("components.performanceTable.movedUp");
};

/**
* | countPlural | output |
* | --- | --- |
* | "one" | "Moved up {count} place" |
* | "other" | "Moved up {count} places" |
*
* @param {Components_Performancetable_Movedup2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_performancetable_movedup2 = /** @type {((inputs: Components_Performancetable_Movedup2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Performancetable_Movedup2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_performancetable_movedup2(inputs)
	if (locale === "ms") return ms_components_performancetable_movedup2(inputs)
	if (locale === "da") return da_components_performancetable_movedup2(inputs)
	if (locale === "de") return de_components_performancetable_movedup2(inputs)
	if (locale === "en-US") return en_us2_components_performancetable_movedup2(inputs)
	if (locale === "es-ES") return es_es2_components_performancetable_movedup2(inputs)
	if (locale === "es-MX") return es_mx2_components_performancetable_movedup2(inputs)
	if (locale === "fil") return fil_components_performancetable_movedup2(inputs)
	if (locale === "fr") return fr_components_performancetable_movedup2(inputs)
	if (locale === "it") return it_components_performancetable_movedup2(inputs)
	if (locale === "hu") return hu_components_performancetable_movedup2(inputs)
	if (locale === "nl") return nl_components_performancetable_movedup2(inputs)
	if (locale === "no") return no_components_performancetable_movedup2(inputs)
	if (locale === "pl") return pl_components_performancetable_movedup2(inputs)
	if (locale === "pt-BR") return pt_br2_components_performancetable_movedup2(inputs)
	if (locale === "pt") return pt_components_performancetable_movedup2(inputs)
	if (locale === "ro") return ro_components_performancetable_movedup2(inputs)
	if (locale === "fi") return fi_components_performancetable_movedup2(inputs)
	if (locale === "sv") return sv_components_performancetable_movedup2(inputs)
	if (locale === "vi") return vi_components_performancetable_movedup2(inputs)
	if (locale === "tr") return tr_components_performancetable_movedup2(inputs)
	if (locale === "cs") return cs_components_performancetable_movedup2(inputs)
	if (locale === "bg") return bg_components_performancetable_movedup2(inputs)
	if (locale === "ru") return ru_components_performancetable_movedup2(inputs)
	if (locale === "uk") return uk_components_performancetable_movedup2(inputs)
	if (locale === "ar") return ar_components_performancetable_movedup2(inputs)
	if (locale === "hi") return hi_components_performancetable_movedup2(inputs)
	if (locale === "th") return th_components_performancetable_movedup2(inputs)
	if (locale === "ja") return ja_components_performancetable_movedup2(inputs)
	if (locale === "zh-CN") return zh_cn2_components_performancetable_movedup2(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_performancetable_movedup2(inputs)
	return ko_components_performancetable_movedup2(inputs)
});
export { components_performancetable_movedup2 as "components.performanceTable.movedUp" }